import * as ErrorList from './SGWTConnectErrorList';

interface IErrorList {
  [key: string]: any;
}

/**
 * SGWTConnect error.
 *
 * The purpose of this class is to differentiate custom SGWTConnect
 * errors from errors originated in other modules.
 */
export class SGWTConnectError extends Error {
  /**
   * Error code from SGWTConnect, OAuth 2.0, OpenID, etc.
   *
   * Use this error code to check for a particular error,
   * for example:
   *
   *    import {ERR_STATE_MISMATCH} from '@sgwt/connect-core';
   *    import {sgwtConnect} from './sgwt-connect';
   *
   *    const error = sgwtConnect.getAuthorizationError();
   *    if (error && error.code === ERR_STATE_MISMATCH) {
   *      // Do something about this error...
   *    }
   */
  public code: string;

  constructor(code: string) {
    const errorListKey = `ERR_${code.toUpperCase()}_DESCRIPTION`;
    const description = (ErrorList as IErrorList)[errorListKey];

    super(`SGWTConnectError ${code.toUpperCase()} ${description}`);

    // Calling `super` in TypeScript 2.1 and 2.2 breaks the
    // prototype chain, so we need to restore it here to
    // enable instanceof checks
    // See: https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#typescript-21
    Object.setPrototypeOf(this, SGWTConnectError.prototype);

    // We use the same approach as NodeJS errors by exposing
    // a `code` property (e.g. "state_mismatch") on error
    // instances:
    this.code = code;
  }
}
